// frontend/admin-portal/src/components/settings/items/SettingItem.jsx
import React from "react";

export default function SettingItem({ label, description, children }) {
  return (
    <div className="fh-setting-item">
      <div className="fh-setting-item__meta">
        <div className="fh-setting-item__label">{label}</div>
        {description && (
          <p className="fh-setting-item__description">{description}</p>
        )}
      </div>
      <div className="fh-setting-item__control">{children}</div>
    </div>
  );
}
